/**
 * Bilingual copy for BlogCard.
 * `en` holds the exact original English strings; `km` mirrors them in Khmer.
 */
export const en = {
  publishedOn: 'Published on',
};

export type Copy = typeof en;

export const km: Copy = {
  publishedOn: 'ចេញផ្សាយថ្ងៃទី',
};
